import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface TagUsersTabProps { tagId: string; }

export const TagUsersTab = ({ tagId }: TagUsersTabProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  // No backend API for user-tag assignments — show empty state
  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input placeholder="Search users..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="pl-10" />
      </div>
      <div className="text-center py-12 text-muted-foreground">
        User tag assignments require a backend User Tags API. Coming soon.
      </div>
    </div>
  );
};
